const AUTHOR = {
    name: 'Uros',
    jobTitle: 'Founder & Developer',
    path: '/about/uros',
    url: 'https://luckynote.io/about/uros',
    sameAs: ['https://x.com/LuckynoteHQ', 'https://www.instagram.com/lucky_uros/'],
    bio: 'I built Luckynote after years of messaging myself notes because it was the fastest way to catch thoughts before they disappeared. I still use that habit every day, and I also pay for and use the other apps I compare so I can judge capture speed, retrieval, pricing, and platform coverage from real use.'
};

module.exports = {
    AUTHOR
};
